// src/views/ocorrencias/OcorrenciaModal.jsx
import React, { useState, useEffect } from "react";
import condominosService from "../../services/condominosService";
import unidadesService from "../../services/unidadesService";
import areasConunsService from "../../services/areasConunsService";

const TIPOS = [
  {v:"Reclamacao",l:"Reclamação"},{v:"Manutencao",l:"Manutenção"},
  {v:"Solicitacao",l:"Solicitação"},{v:"Infracao",l:"Infração"},
  {v:"Acidente",l:"Acidente"},{v:"Seguranca",l:"Segurança"},
  {v:"Sugestao",l:"Sugestão"},{v:"Outro",l:"Outro"},
];
const PRIORIDADES = ["Urgente","Alta","Media","Baixa"];
const PRIORIDADE_LABEL = {Urgente:"Urgente",Alta:"Alta",Media:"Média",Baixa:"Baixa"};
const PRIORIDADE_STYLE = {
  Urgente:{bg:"#FEE2E2",color:"#991B1B"},
  Alta:   {bg:"#FFF7ED",color:"#C2410C"},
  Media:  {bg:"#FEF9C3",color:"#854D0E"},
  Baixa:  {bg:"#F0FDF4",color:"#166534"},
};

const EMPTY = {
  titulo:"", descricao:"", tpOcorrencia:"Reclamacao", prioridade:"Media",
  idUnidade:"", idCondomino:"", idAreaComum:"",
  abertoPor:"Administrador", nmAbertoPor:"Administrador",
  responsavel:"", gerarMulta:false, vlrMulta:"",
  observacao:"",
};

export default function OcorrenciaModal({ show, onClose, onSave, editData, saving=false, idCondominio, condominioNome="" }) {
  const isEdit = !!editData?.id;
  const [form, setForm]     = useState(EMPTY);
  const [errors, setErrors] = useState({});
  const [tab, setTab]       = useState("dados");
  const [unidades,         setUnidades]   = useState([]);
  const [unidadesFiltradas, setUnidadesFiltradas] = useState([]);
  const [vincMap, setVincMap]           = useState({});
  const [revVincMap, setRevVincMap]       = useState({});
  const [condominosFiltrados, setCondominosFiltrados] = useState(null); // null = show all
  const [condominos, setCondominos] = useState([]);
  const [areas, setAreas]   = useState([]);

  useEffect(() => {
    if (!idCondominio) return;
    unidadesService.listar({ idCondominio, limit:500 }).then(r=>setUnidades(r.data||[])).catch(()=>{});
    condominosService.listarSelect(idCondominio).then(r=>setCondominos(r.data||[])).catch(()=>{});
    areasConunsService.listar({ idCondominio, situacao:"Ativa" }).then(r=>setAreas(r.data||[])).catch(()=>{});
  },[idCondominio]);

  useEffect(() => {
    if (!show) return;
    setForm(editData ? {...EMPTY,...editData} : {...EMPTY});
    setErrors({}); setTab("dados");
  },[show, editData]);

  // Build vincMap: idCondomino → [idUnidade] from unidade_vinculos
  useEffect(() => {
    if (!unidades.length) return;
    import("../../services/vinculosService").then(m => {
      Promise.all(unidades.map(u => m.default.listar(u.id).catch(()=>({data:[]}))))
        .then(results => {
          const map = {};
          results.forEach((r, i) => {
            (r.data||[]).forEach(v => {
              if (v.idCondomino && v.ativo) {
                const key = String(v.idCondomino);
                if (!map[key]) map[key] = [];
                if (!map[key].includes(unidades[i].id)) map[key].push(unidades[i].id);
              }
            });
          });
          setVincMap(map);
        });
    });
  }, [unidades]);

  // Filtra unidades pelo condômino selecionado (busca direto da API)
  useEffect(() => {
    if (!form.idCondomino) {
      setUnidadesFiltradas([]);
      return;
    }
    condominosService.listarUnidades(form.idCondomino)
      .then(r => setUnidadesFiltradas(r.data||[]))
      .catch(()=>setUnidadesFiltradas([]));
  },[form.idCondomino]);

  const set = (f,v) => { setForm(p=>({...p,[f]:v})); setErrors(p=>({...p,[f]:undefined})); };

  const validate = () => {
    const e={};
    if(!form.titulo.trim())    e.titulo="Título é obrigatório";
    if(!form.descricao.trim()) e.descricao="Descrição é obrigatória";
    if(form.gerarMulta && (!form.vlrMulta||parseFloat(form.vlrMulta)<=0)) e.vlrMulta="Informe o valor da multa";
    setErrors(e);
    if(Object.keys(e).length){ setTab("dados"); return false; }
    return true;
  };

  if (!show) return null;

  const tabs = [
    {id:"dados",     label:"Dados Gerais",   icon:"bi-exclamation-circle"},
    {id:"detalhes",  label:"Detalhes",       icon:"bi-card-text"},
  ];

  return (
    <div className="modal fade show d-block" style={{background:"rgba(0,0,0,.55)"}} tabIndex="-1">
      <div className="modal-dialog modal-lg modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <div className="d-flex align-items-center gap-3">
              <div style={{width:38,height:38,background:"rgba(255,255,255,.15)",borderRadius:8,display:"flex",alignItems:"center",justifyContent:"center"}}>
                <i className="bi bi-exclamation-circle" style={{fontSize:18,color:"#fff"}}/>
              </div>
              <div>
                <h5 className="modal-title mb-0">{isEdit?"Editar Ocorrência":"Nova Ocorrência"}</h5>
                <small style={{color:"rgba(255,255,255,.6)",fontSize:12}}>{condominioNome}</small>
              </div>
            </div>
            <button className="btn-close btn-close-white" onClick={onClose}/>
          </div>

          <div style={{background:"var(--primary)",padding:"0 24px"}}>
            <ul className="nav nav-tabs border-0" style={{gap:4}}>
              {tabs.map(t=>(
                <li key={t.id} className="nav-item">
                  <button className={`nav-link border-0 d-flex align-items-center gap-2 ${tab===t.id?"active":""}`}
                    style={{background:tab===t.id?"#fff":"transparent",color:tab===t.id?"var(--primary)":"rgba(255,255,255,.7)",
                      borderRadius:"6px 6px 0 0",fontSize:13,fontWeight:500,padding:"10px 18px"}}
                    onClick={()=>setTab(t.id)}>
                    <i className={`bi ${t.icon}`}/>{t.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="modal-body">

            {tab==="dados"&&(
              <>
                {/* Prioridade — seleção visual */}
                <div className="form-section">
                  <div className="form-section-title"><i className="bi bi-flag"/> Classificação</div>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label className="form-label">Tipo de Ocorrência</label>
                      <div style={{display:"flex",flexWrap:"wrap",gap:6,marginTop:4}}>
                        {TIPOS.map(t=>(
                          <button key={t.v} type="button"
                            style={{padding:"5px 12px",borderRadius:16,fontSize:12.5,fontWeight:500,cursor:"pointer",border:"2px solid",
                              borderColor:form.tpOcorrencia===t.v?"var(--primary)":"var(--gray-300)",
                              background:form.tpOcorrencia===t.v?"var(--primary)":"#fff",
                              color:form.tpOcorrencia===t.v?"#fff":"var(--gray-600)"}}
                            onClick={()=>set("tpOcorrencia",t.v)}>
                            {t.l}
                          </button>
                        ))}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Prioridade</label>
                      <div style={{display:"flex",gap:6,marginTop:4}}>
                        {PRIORIDADES.map(p=>(
                          <button key={p} type="button"
                            style={{padding:"5px 14px",borderRadius:16,fontSize:12.5,fontWeight:600,cursor:"pointer",border:"2px solid",flex:1,
                              borderColor:form.prioridade===p?PRIORIDADE_STYLE[p].color:"var(--gray-300)",
                              background:form.prioridade===p?PRIORIDADE_STYLE[p].bg:"#fff",
                              color:form.prioridade===p?PRIORIDADE_STYLE[p].color:"var(--gray-600)"}}
                            onClick={()=>set("prioridade",p)}>
                            {PRIORIDADE_LABEL[p]}
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="form-section">
                  <div className="form-section-title"><i className="bi bi-card-text"/> Descrição</div>
                  <div className="row g-3">
                    <div className="col-12">
                      <label className="form-label">Título <span className="required-mark">*</span></label>
                      <input className={`form-control ${errors.titulo?"is-invalid":""}`}
                        value={form.titulo} onChange={e=>set("titulo",e.target.value)}
                        placeholder="Resumo da ocorrência..."/>
                      {errors.titulo&&<div className="invalid-feedback">{errors.titulo}</div>}
                    </div>
                    <div className="col-12">
                      <label className="form-label">Descrição Detalhada <span className="required-mark">*</span></label>
                      <textarea className={`form-control ${errors.descricao?"is-invalid":""}`} rows={4}
                        value={form.descricao} onChange={e=>set("descricao",e.target.value)}
                        placeholder="Descreva a ocorrência em detalhes..."/>
                      {errors.descricao&&<div className="invalid-feedback">{errors.descricao}</div>}
                    </div>
                  </div>
                </div>
              </>
            )}

            {tab==="detalhes"&&(
              <>
                <div className="form-section">
                  <div className="form-section-title"><i className="bi bi-geo-alt"/> Localização / Vínculo</div>
                  <div className="row g-3">
                    <div className="col-md-4">
                      <label className="form-label">Condômino Envolvido</label>
                      <select className="form-select" value={form.idCondomino}
                        onChange={e=>{
                          const idCond = e.target.value;
                          set("idCondomino", idCond);
                          set("idUnidade", "");
                          setCondominosFiltrados(null); // reset filter when condômino selected
                          if (idCond) {
                            const ids = vincMap[String(idCond)] || [];
                            const uvs = ids.length > 0
                              ? unidades.filter(u => ids.includes(u.id))
                              : unidades;
                            setUnidadesFiltradas(uvs);
                            if (uvs.length === 1) set("idUnidade", String(uvs[0].id));
                          } else {
                            setUnidadesFiltradas(unidades);
                          }
                        }}>
                        <option value="">— Sem envolvido —</option>
                        {(condominosFiltrados !== null ? condominosFiltrados : condominos
                        ).map(cn=><option key={cn.id} value={cn.id}>{cn.nmCompleto}</option>)}
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Unidade Envolvida</label>
                      <select className="form-select" value={form.idUnidade} onChange={async e=>{
                            const idUn = e.target.value;
                            set("idUnidade", idUn);
                            set("idCondomino", "");
                            if (idUn) {
                              try {
                                const r = await unidadesService.listarCondominos(idUn);
                                const lista = r.data || [];
                                setCondominosFiltrados(lista.length > 0 ? lista : null);
                                if (lista.length === 1) set("idCondomino", String(lista[0].id));
                              } catch { setCondominosFiltrados(null); }
                            } else {
                              setCondominosFiltrados(null);
                            }
                        }}>
                        <option value="">— Sem vínculo —</option>
                        {(unidadesFiltradas.length>0?unidadesFiltradas:unidades).map(u=>(
                          <option key={u.id} value={u.id}>{u.unidade}{u.bloco?` / Bl.${u.bloco}`:""}</option>
                        ))}
                      </select>
                      {form.idCondomino&&unidadesFiltradas.length===0&&(
                        <small style={{color:"#F59E0B",fontSize:11}}>Nenhuma unidade vinculada a este condômino</small>
                      )}
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Área Comum Relacionada</label>
                      <select className="form-select" value={form.idAreaComum} onChange={e=>set("idAreaComum",e.target.value)}>
                        <option value="">— Nenhuma —</option>
                        {areas.map(a=><option key={a.id} value={a.id}>{a.nmArea}</option>)}
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Aberto Por</label>
                      <select className="form-select" value={form.abertoPor} onChange={e=>set("abertoPor",e.target.value)}>
                        <option value="Administrador">Administrador</option>
                        <option value="Condomino">Condômino</option>
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Nome do Solicitante</label>
                      <input className="form-control" value={form.nmAbertoPor} onChange={e=>set("nmAbertoPor",e.target.value)}/>
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Responsável pela Resolução</label>
                      <input className="form-control" value={form.responsavel} onChange={e=>set("responsavel",e.target.value)}
                        placeholder="Ex: Síndico, Zelador..."/>
                    </div>
                  </div>
                </div>

                {/* Multa para infrações */}
                {form.tpOcorrencia==="Infracao"&&(
                  <div className="form-section">
                    <div className="form-section-title"><i className="bi bi-cash-coin"/> Multa por Infração</div>
                    <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:12}}>
                      <div className="form-check form-switch mb-0">
                        <input className="form-check-input" type="checkbox" id="gerarMulta"
                          checked={form.gerarMulta} onChange={e=>set("gerarMulta",e.target.checked)}/>
                        <label className="form-check-label" htmlFor="gerarMulta" style={{fontWeight:500,fontSize:13}}>
                          Gerar multa ao criar a ocorrência
                        </label>
                      </div>
                    </div>
                    {form.gerarMulta&&(
                      <div className="row g-3">
                        <div className="col-md-4">
                          <label className="form-label">Valor da Multa (R$) <span className="required-mark">*</span></label>
                          <div className="input-group">
                            <span className="input-group-text">R$</span>
                            <input className={`form-control ${errors.vlrMulta?"is-invalid":""}`}
                              type="number" step="0.01" min="0.01" value={form.vlrMulta}
                              onChange={e=>set("vlrMulta",e.target.value)}/>
                            {errors.vlrMulta&&<div className="invalid-feedback">{errors.vlrMulta}</div>}
                          </div>
                          <small style={{fontSize:11,color:"var(--gray-400)"}}>Gera lançamento no Contas a Receber</small>
                        </div>
                      </div>
                    )}
                  </div>
                )}

                <div className="form-section">
                  <div className="form-section-title"><i className="bi bi-chat-text"/> Observações</div>
                  <textarea className="form-control" rows={3} value={form.observacao}
                    onChange={e=>set("observacao",e.target.value)}
                    placeholder="Observações adicionais..."/>
                </div>
              </>
            )}
          </div>

          <div className="modal-footer d-flex justify-content-between">
            <div style={{fontSize:12,color:"var(--gray-400)"}}>
              <i className="bi bi-asterisk me-1" style={{color:"#ef4444",fontSize:9}}/>Campos obrigatórios
            </div>
            <div className="d-flex gap-2">
              <button className="btn btn-outline-secondary" onClick={onClose}><i className="bi bi-x-circle"/> Cancelar</button>
              <button className="btn btn-primary" onClick={()=>{if(validate()) onSave({...form,id:editData?.id});}} disabled={saving}>
                {saving?<><span className="spinner-border spinner-border-sm me-2"/>Salvando...</>:<><i className="bi bi-check-circle"/> {isEdit?"Salvar":"Registrar"}</>}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
